import { parseStringAmountWithUnitToNumber } from "../formaters";

export const DeclaredIncomeDataMapper = {
  hydrate(data) {
    return {
      id: data.id,
      loan_id: data.loanId,
      borrower_id: data.borrowerId,
      monthly_net_income_currency: "EUR",
      annual_net_income_currency: "EUR",
      annual_net_income_amount:
        parseStringAmountWithUnitToNumber(data.monthlyIncome) *
        data.numberOfPaymentsPerYear,
      monthly_net_income_amount: parseStringAmountWithUnitToNumber(
        data.monthlyIncome
      ),
      net_income_type: data.netIncomeType,
    };
  },
};
